import {DeliveryType} from 'src/shared/types'

/**
 * Типы вертикалей, которые относятся к бизнес-тарифу
 */
export const BUSINESS_VERTICALS: string[] = [DeliveryType.NDD_Shipment]
